export const initialAbility = [
  {
    action: 'manage',
    subject: 'auth',
  },
]

export const _ = undefined
